export default __webpack_public_path__ + "static/skilled-ba6fa3ce93e15d1b9220b338ae7d8322.png";